(function ($) {
  if (!$ || !$.fn) return;

$(document).ready(function () {
  // featured product tab
  $(document).on("click", ".tab_title ul li ", function () {
    var url = $(this).attr("data-url");
    var tab_id = $(this).attr("data-tab");
    $(this).closest(".opposing-items").find("a.more-link").attr("href", url);
    $(".tab_title ul li").removeClass("current");
    $(".tab_section .tab_box").removeClass("current");
    $(this).addClass("current");
    $("#" + tab_id).addClass("current");
  });

  // search collection url

  $(".main-search__product-types").on("change", function () {
    var Url_value = $(this).find(":selected").val();
    window.location.href = Url_value;
  });

  // Tags Filter
  $("#tag__filter").on("change", function () {
    var Url_value = $(this).find(":selected").val();
    window.location.href = Url_value;
  });

  // Blog Faq
  $(".acc__title").click(function (j) {
    var dropDown = $(this).closest(".acc__card").find(".acc__panel");
    $(this).closest(".acc").find(".acc__panel").not(dropDown).slideUp();

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      $(this).closest(".acc").find(".acc__title.active").removeClass("active");
      $(this).addClass("active");
    }

    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });

  // blog sliders
  if (typeof $.fn.slick === "function") {
    // blog review slider
  
  
  
    $(".blog_review_slider")
  
      .slick({
  
        dots: false,
  
        infinite: false,
  
        adaptiveHeight: true,
  
        arrows: true,
  
        speed: 300,
  
        slidesToShow: 3,
  
        slidesToScroll: 1,
  
        prevArrow:
  
          '<button type="button" class="slick-arrow slick-prev pull-left" aria-label="Previous slide"><svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 25L1 13L13 1" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  
        nextArrow:
  
          '<button type="button" class="slick-arrow slick-next pull-right" aria-label="Next slide"><svg width="14" height="26" viewBox="0 0 14 26" fill="#000" xmlns="http://www.w3.org/2000/svg"><path d="M1 25L13 13L1 1" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  
        responsive: [
  
          {
  
            breakpoint: 1024,
  
            settings: {
  
              slidesToShow: 3,
  
              slidesToScroll: 3,
  
              infinite: true,
  
              dots: true,
  
            },
  
          },
  
          {
  
            breakpoint: 990,
  
            settings: {
  
              slidesToShow: 2,
  
              slidesToScroll: 2,
  
            },
  
          },
  
          {
  
            breakpoint: 480,
  
            settings: {
  
              slidesToShow: 1,
  
              slidesToScroll: 1,
  
            },
  
          },
  
        ],
  
      })
  
      .on("setPosition", function (event, slick) {
  
        slick.$slides.css("height", slick.$slideTrack.height() + "px");
  
      });
  
  
  
    $(".blog_slider").slick({
  
      dots: true,
  
      infinite: false,
  
      adaptiveHeight: true,
  
      arrows: true,
  
      speed: 300,
  
      slidesToShow: 3,
  
      slidesToScroll: 1,
  
      prevArrow:
  
        '<button type="button" class="slick-arrow slick-prev pull-left" aria-label="Previous slide"><svg width="14" height="26" viewBox="0 0 14 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 25L1 13L13 1" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  
      nextArrow:
  
        '<button type="button" class="slick-arrow slick-next pull-right" aria-label="Next slide"><svg width="14" height="26" viewBox="0 0 14 26" fill="#000" xmlns="http://www.w3.org/2000/svg"><path d="M1 25L13 13L1 1" stroke="black" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  
      responsive: [
  
        {
  
          breakpoint: 1024,
  
          settings: {
  
            slidesToShow: 3,
  
            slidesToScroll: 3,
  
            infinite: true,
  
            dots: true,
  
          },
  
        },
  
        {
  
          breakpoint: 990,
  
          settings: {
  
            slidesToShow: 2,
  
            slidesToScroll: 2,
  
          },
  
        },
  
        {
  
          breakpoint: 640,
  
          settings: {
  
            slidesToShow: 1,
  
            slidesToScroll: 1,
  
          },
  
        },
  
      ],
  
    });
  
  
  
    }

  // blog third party link new tab

  $(".template-article a").each(function () {
    if ($(this).is('[href*="http"')) {
      $(this).attr("target", "_blank");
    }
  });

  // custom popup
  $(document).on("click", ".Subscribe_button", function (event) {
    $(".custom_popup").fadeIn();
    event.preventDefault();
  });
  $(document).on("click", ".pop_close_btn", function () {
    $(".custom_popup").fadeOut();
  });
});

})(window.jQuery || window.$);
